import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { bindActionCreators } from "redux";
import Modal from "react-modal";

import * as SettingActions from "./../actions/settingScreen_actions";

let passwordToProceedModal = React.createClass({
  getInitialState() {
    return {
      // Password verification
      showPasswordModal: this.props.showPasswordToProceeed,
      isVerifyPasswordSubmitted: false,
      invalidPasswordErrorMsg: null,
    };
  },
  componentWillReceiveProps(nextProps) {
    nextProps.showPasswordToProceeed
      ? this.setState({ showPasswordModal: nextProps.showPasswordToProceeed })
      : "";

    // Password Verification Response
    if (this.state.isVerifyPasswordSubmitted) {
      if (nextProps.VerifyPasswordResponse.status == 200) {
        nextProps.VerifyPasswordResponse.status = "";
        this.setState({
          showPasswordModal: false,
        });
        this.props.passwordVerified(true);
      } else {
        this.setState({
          invalidPasswordErrorMsg: nextProps.VerifyPasswordResponse.message,
        });
      }

      this.setState({
        isVerifyPasswordSubmitted: null,
      });
    }
  },

  componentWillMount() {
    // this.setState({
    //     showPasswordModal: true
    // })
  },

  componentDidMount() {},
  handleKeyPress(e) {
    if (e.key === "Enter") {
      this.verifyPassword();
    }
  },
  verifyPassword() {
    if (this.refs.oldPassword.value != "") {
      var PassCheck = {
        id: this.props.LoginDetails.data.id,
        uniqueKey: this.props.LoginDetails.data.uniqueKey,
        password: this.refs.oldPassword.value,
      };
      this.setState({
        invalidPasswordErrorMsg: null,
        isVerifyPasswordSubmitted: true,
      });
      this.props.Dispatch(SettingActions.verifyPass(PassCheck));
    } else {
      this.setState({
        isVerifyPasswordSubmitted: null,
        invalidPasswordErrorMsg: "Please enter valid password.",
      });
    }
  },

  removeCancelPrompt() {
    this.setState({
      showPasswordModal: false,
      invalidPasswordErrorMsg: null,
    });
    this.props.passwordVerified(false);
  },

  removeInvalidPasswordErrorMsg() {
    this.setState({
      invalidPasswordErrorMsg: null,
    });
  },
  togglePassword() {
    var pwd = document.getElementById("password");
    pwd.type === "password" ? (pwd.type = "text") : (pwd.type = "password");
  },

  render() {
    var style = {
      color: "red",
    };
    return (
      <Modal
        isOpen={this.state.showPasswordModal}
        className="delete-prompt modalPopup logout"
        contentLabel="modalPopup"
      >
        <div className="popup-content profile text-center">
          <p className="main_header">Please enter your password to proceed.</p>
          <div>
            <div className="input-group">
              <div className="input-group">
                <input
                  type="password"
                  ref="oldPassword"
                  className="inputText"
                  id="password"
                  onChange={this.removeInvalidPasswordErrorMsg}
                  onKeyPress={this.handleKeyPress}
                  required
                />
                <span className="floating-label">PASSWORD</span>
                <img
                  src={require("./../images/eye-open.png")}
                  className="eye-icon"
                  onClick={() => {
                    this.togglePassword();
                  }}
                />
              </div>
              {this.state.invalidPasswordErrorMsg && (
                <div className="error-message">
                  <span style={style}>
                    {this.state.invalidPasswordErrorMsg}{" "}
                  </span>
                </div>
              )}
            </div>
            <input
              type="button"
              value="SUBMIT"
              className="button button-primary btn-submit gray-button"
              ref="deleteBtn"
              onClick={this.verifyPassword}
              onKeyPress={this.handleKeyPress}
            />
            <input
              type="button"
              value="CANCEL"
              className="button button-primary btn-submit white-button"
              ref="deleteCancelBtn"
              onClick={this.removeCancelPrompt}
            />
          </div>
        </div>
      </Modal>
    );
  },
});

let mapStateToProps = (state) => {
  return {
    LoginDetails: state.User.loginData,
    VerifyPasswordResponse: state.Setting.verification,
  };
};

let mapDispatchToProps = (dispatch) => ({
  Dispatch: dispatch,
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(passwordToProceedModal));



/** WEBPACK FOOTER **
 ** ./src/components/passwordToProceedModal.jsx
 **/